import Checkbox, { CHECKBOX_STATE } from 'Components/Atoms/Checkbox/Checkbox';
import ListItem from 'Components/Atoms/Fields/ListItem/ListItem';
import HighlightedText from 'Components/Atoms/HighlightedText/HighlightedText';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import React, { useEffect, useState } from 'react';
import styles from './MultiSelectField.module.sass';

const MultiSelectFieldItem = ({item, iteration, searchQuery, activeValues, onClick, ...props}: any) => {
    const [state, setState] = useState({
        iteration: iteration || 0,
        state: CHECKBOX_STATE.INACTIVE
    });

    useEffect(() => {
        if (item?.children) {
            let target = item?.children?.length;
            let total = 0;
            item?.children.forEach((i) => total += (activeValues.includes(i.value) ? 1 : 0));
            setState({...state, state: total == target
                ? CHECKBOX_STATE.ACTIVE
                : (total > 0 && total < target)
                ? CHECKBOX_STATE.SELECTED
                : CHECKBOX_STATE.INACTIVE
            });
            
            return;
        }
        
        if (activeValues.includes(item.value)) {
            setState({...state, state: CHECKBOX_STATE.ACTIVE});
            
            return;
        }

        setState({...state, state: CHECKBOX_STATE.INACTIVE});
    }, [activeValues]);

    const handleClick = () => {
        if (item?.children) {
            const values = item.children?.map(i => i.value);
            const totalValueInValues = values.filter(i => activeValues.includes(i));
            if (totalValueInValues.length > 0) {
                onClick([...totalValueInValues]);
            } else {
                onClick([...values]);
            }
            
            return;
        }
        
        onClick([item.value]);
    };
    const handleChildClick = (v) => onClick(v);

    return <ListItem
            hasChildren={!!item?.children}
            iteration={iteration}
            label={
                <>
                    <div style={{width: !item.children ? '100%' : 'auto'}}>
                        { item.id }
                        <Checkbox
                            label={<HighlightedText highlight={searchQuery || ''}>{props.labels && props.labels?.[item.value]}</HighlightedText>}
                            onClick={handleClick}
                            state={state.state}
                        />
                    </div>

                    {
                        item.total &&
                        <div className={styles['dropdown__item-count']}>({item.selected > 0 ? item.selected + '/' : ''}{item.total})</div>
                    }

                    {
                        item.children &&
                        <div className={styles[`dropdown__item-arrow`]}>
                            <Icon
                                type={ICONS.CHEVRON_DOWN}
                                size={'small'}
                            />
                        </div>
                    }
                </>
            }    
        >
        {
            item?.children?.map((child) => <MultiSelectFieldItem
                key={child.id}
                item={child}
                labels={props.labels}
                iteration={state.iteration+1}
                activeValues={activeValues}
                searchQuery={searchQuery}
                onClick={handleChildClick}
            />)
        }
    </ListItem>;
}

export default MultiSelectFieldItem;